/* eslint-disable no-param-reassign */
import produce from 'immer';
var secondaryAnalysisStatusLoading = produce(function (draft, action) {
  var secondaryAnalysisId = action.payload.secondaryAnalysisId;
  draft[secondaryAnalysisId].status.loading = true;
});
export default secondaryAnalysisStatusLoading;